@if (!$screenshotMode()) {
  <transition-view-container
    [views]="views"
    [view]="$currentView()"
    height="auto"
  >
    <transition-view [view]="View.MAIN">
      <ng-container viewBody>
        <ng-container [ngTemplateOutlet]="mainView"></ng-container>
      </ng-container>
    </transition-view>
    <transition-view [view]="View.QR_CODE">
      <ng-container viewBody>
        <ng-container [ngTemplateOutlet]="qrCodeView"></ng-container
      ></ng-container>
    </transition-view>
  </transition-view-container>
}

<disable-autofocus></disable-autofocus>

<ng-template #mainView>
  @if ($entityType() === "hang") {
    <div mat-dialog-title>
      Hang invites
      <div class="subtitle">Invite people to join this Hang</div>
    </div>
  } @else if ($entityType() === "pueblo") {
    <div mat-dialog-title>
      Pueblo invites
      <div class="subtitle">Invite people to subscribe to this Pueblo</div>
    </div>
  }

  <div mat-dialog-content>
    @if ($userModels().length) {
      <div class="section-title title-small on-surface-text">
        Direct invites
      </div>

      <user-list
        [users]="$userModels()"
        [expanded]="true"
        padding="8px 0px"
        class="surface-container-lowest"
      ></user-list>
    }

    <div class="section-title title-small on-surface-text">
      External invites
      <button
        mat-stroked-button
        [matMenuTriggerFor]="menu"
        class="invite-button"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
        Send invite
      </button>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="copyShortUrl()">
        <mat-icon>link</mat-icon>
        Copy URL
      </button>
      @if ($canShare()) {
        <button mat-menu-item (click)="handleShare()">
          <mat-icon [class.ios-share]="platform.browser === 'safari'">
            {{ platform.browser === "safari" ? "ios_share" : "share" }}
          </mat-icon>
          Share
        </button>
      }
      <button mat-menu-item (click)="$currentView.set(View.QR_CODE)">
        <mat-icon>qr_code_2</mat-icon>
        QR Code
      </button>
    </mat-menu>
  </div>
</ng-template>

<ng-template #qrCodeView>
  @if (!$screenshotMode()) {
    @if ($entityType() === "hang") {
      <div mat-dialog-title>Join my {{ $entityDisplayName() }} Hang</div>
    } @else if ($entityType() === "pueblo") {
      <div mat-dialog-title>
        Subscribe to
        <div>{{ $emoji() }} {{ $entityDisplayName() }}</div>
        <div class="subtitle">Get notified of Hangs in this Pueblo</div>
      </div>
    }
    <div mat-dialog-content class="content">
      <div class="qrcode-image" #qrCodeContainer>
        <qrcode
          [qrdata]="$url()"
          [allowEmptyString]="true"
          [ariaLabel]="'QR Code image with the following content...'"
          [cssClass]="'center'"
          [colorDark]="$qrCodeColor()"
          [colorLight]="$qrBackgroundColor()"
          [elementType]="'svg'"
          [errorCorrectionLevel]="'Q'"
          [margin]="0"
          [scale]="10"
          [title]="'A custom title attribute'"
          [width]="250"
          #qrCode
        ></qrcode>
        <div class="center-content">
          @if ($emoji()) {
            <div class="emoji" [class.emoji-only]="!$puebloBelowEmoji()">
              {{ $emoji() }}
            </div>
            @if ($puebloBelowEmoji()) {
              <div class="pueblo-logo-small pueblo-font">pueblo</div>
            }
          } @else {
            <div
              class="pueblo-logo-large pueblo-font"
              [style.color]="$logoColor()"
              [class.emoji-visible]="!!$emoji()"
            >
              p
            </div>
          }
        </div>
      </div>

      <button
        class="screenshot-mode-button"
        mat-button
        (click)="$screenshotMode.set(true)"
      >
        Screenshot Mode
      </button>

      <button mat-flat-button (click)="$currentView.set(View.MAIN)">
        Go Back
      </button>
    </div>
  }
</ng-template>

@if ($screenshotMode()) {
  <div class="content" [class.screenshot-mode]="$screenshotMode()">
    <div class="screenshot-mode-spacer"></div>
    @if ($entityType() === "hang") {
      <div class="title title-medium">
        Join my {{ $entityDisplayName() }} Hang
      </div>
    } @else if ($entityType() === "pueblo") {
      <div class="title headline-medium">Let's Hang!</div>
      <div class="subtitle title-medium">
        Subscribe to my {{ $entityDisplayName() }} Pueblo
      </div>
    }
    <div class="qrcode-image" #qrCodeContainer>
      <qrcode
        [qrdata]="$url()"
        [allowEmptyString]="true"
        [ariaLabel]="'QR Code image with the following content...'"
        [cssClass]="'center'"
        [colorDark]="$qrCodeColor()"
        [colorLight]="$qrBackgroundColor()"
        [elementType]="'svg'"
        [errorCorrectionLevel]="'Q'"
        [margin]="0"
        [scale]="10"
        [title]="'A custom title attribute'"
        [width]="250"
        #qrCode
      ></qrcode>
      <div class="center-content">
        @if ($emoji()) {
          <div class="emoji" [class.emoji-only]="!$puebloBelowEmoji()">
            {{ $emoji() }}
          </div>
          @if ($puebloBelowEmoji()) {
            <div class="pueblo-logo-small pueblo-font">pueblo</div>
          }
        } @else {
          <div
            class="pueblo-logo-large pueblo-font"
            [style.color]="$logoColor()"
            [class.emoji-visible]="!!$emoji()"
          >
            p
          </div>
        }
      </div>
    </div>
    @if ($screenshotMode()) {
      <div class="headline-medium pueblo-font screenshot-pueblo-logo">
        pueblo
      </div>
    }
    <div class="screenshot-mode-spacer"></div>

    <button mat-raised-button (click)="$screenshotMode.set(false)">
      Go Back
    </button>
  </div>
}
